<template>
  <div class="picha">
    <div class="in">
      <img
        src="../../assets/img/alert/iconos_sitio publico-08.png"
        alt="alert"
        class="alert-image"
      />
      <p class="alert-text">
        {{ text }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["text"],
};
</script>

<style>
.picha {
  margin: 1rem 0;
  /* height: 100%; */
  color: #052333;
  background: #24c6ab;
  border-radius: 50px;
  text-align: center;
  /* width: 35%; */
  font-size: 0.75rem;
}
.in {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.7rem
}
.alert-image {
  width: 50px;
  margin: 0 4px;
}
.alert-text {
  margin: 0 4px;
}
</style>
